<template>
    <CustomerInfo/>
</template>
<script>
import CustomerInfo from 'operations/customer/customerInfo.vue'
export default {
    components:{
        CustomerInfo
    }
}
</script>